module.exports = __webpack_public_path__ + "static/media/periph_kit_explore3.c513a77e.jpg";